import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { CartAddModal, InventoryGrid, ServiceThreadSpinner } from ".";
import { api, constants, helpers, UserContext } from "../utils";
import { toast } from "react-toastify";

export default function CurrentInventory(props) {
   const { currentUser } = useContext(UserContext);
   const [addToCart, setAddToCart] = useState(null);
   const [allInventory, setAllInventory] = useState([]);
   const [canOrder, setCanOrder] = useState(true);
   const [customerId, setCustomerId] = useState(props.customerId);
   const [data, setData] = useState([]);
   const [includeNoActivityItems, setIncludeNoActivityItems] = useState(true);
   const [loaded, setLoaded] = useState(false);
   const [page, setPage] = useState(1);
   const [sites, setSites] = useState(["PLT"]);
   const [sortDirection, setSortDirection] = useState("asc");
   const [sortField, setSortField] = useState("itemWithDesc");
   const [totalPages, setTotalPages] = useState();
   const usageFilter = {
      yearSalesQty: 0,
      halfYearSalesQty: 0,
      quarterSalesQty: 0,
      monthSalesQty: 0,
   };

   useEffect(() => {
      if (props.customerId !== customerId) {
         setCustomerId(props.customerId);
         setLoaded(false);
      }
      if (!loaded) {
         loadData();
      }
      if (loaded && allInventory.length) {
         filterActiveItems();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId, currentUser, includeNoActivityItems]);

   function createPayload() {
      return {
         CustomerId: props.customerId,
         PageNumber: page,
         PageSize: 10,
         SortField: sortField,
         SortDirection: sortDirection,
      };
   }

   function exportInventoryXLSX() {
      let payload = {
         CustomerId: customerId,
         ShowZeroQuantity: includeNoActivityItems,
         SortField: sortField,
         SortDirection: sortDirection,
      };
      api
         .postGetBlob("Customer/ExportCurrentInventoryXLSX", payload)
         .then((response) => {
            if (response && response.data) {
               const XLSX_FILENAME = `${customerId}_CurrentInventory.xlsx`;
               helpers.downloadExport(
                  response.data,
                  XLSX_FILENAME,
                  constants.MIME_TYPES.xlsx
               );
            } else {
               toast.error(response.message);
               throw new Error("Error downloading report.");
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         });
   }

   function filterActiveItems() {
      if (includeNoActivityItems) {
         setData(allInventory);
         setTotalPages(allInventory.length / 10);
      } else {
         setData(_.reject(allInventory, usageFilter));
         setTotalPages(_.reject(allInventory, usageFilter).length / 10);
      }
   }

   function loadData() {
      api
         .post(`Customer/GetCurrentInventory`, createPayload())
         .then((response) => {
            if (response.data.success) {
               setSites(response.data.sites);            // List of OrderSiteDto.cs
               setAllInventory(response.data.inventory); // List of OrderDetail.cs
               setCanOrder(response.data.canOrder);      // A customer with late balances OR an account on hold cannot order
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));
   }

   function onPageChange(page) {
      setPage(page);
      setLoaded(false);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc");
      } else {
         setSortDirection(direction);
      }
      onPageChange(1);
   }

   return (
      <>
         <div>
            <span className="h2">
               {currentUser?.isAnyCustomerTypeRole
                  ? "Your Products, Usage and Pricing"
                  : "Current Inventory & Availability"}
            </span>
            {/* Label the account actually being displayed, never the user's primary - under
                multi-account those differ and showing the primary mislabels the data. */}
            <span className="text-muted"> Customer #{customerId}</span>
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {allInventory && allInventory.length > 0 ? (
               <InventoryGrid
                  data={data}
                  sites={sites}
                  sortCallback={onSortChange}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  pagerCallback={onPageChange}
                  pageNumber={page}
                  totalPages={totalPages}
                  customerId={customerId}
                  customerName={customerId}
                  refreshData={() => setLoaded(false)}
                  includeNoActivityItems={includeNoActivityItems}
                  setIncludeNoActivityItems={() => setIncludeNoActivityItems(!includeNoActivityItems)}
                  exportXlsxCallback={exportInventoryXLSX}
                  addToCartCallback={setAddToCart}
                  canOrder={canOrder}
               />
            ) : (
               <span className="h5">No Inventory Information</span>
            )}
            {addToCart ? (
               <CartAddModal
                  item={addToCart}
                  exitCallback={() => setAddToCart(null)}
               />
            ) : null}
         </ServiceThreadSpinner>
      </>
   );
}
